import { render, staticRenderFns } from "./Itzb.vue?vue&type=template&id=d95e7076&scoped=true&"
import script from "./Itzb.vue?vue&type=script&lang=js&"
export * from "./Itzb.vue?vue&type=script&lang=js&"
import style0 from "./Itzb.vue?vue&type=style&index=0&id=d95e7076&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95e7076",
  null
  
)

export default component.exports